// Canonicalizes HTML `accept` attribute tokens (file-type restrictions) entered in the
// properties panel. Valid token shapes: ".ext" (extension), "type/subtype" (exact MIME),
// "type/*" (MIME wildcard). Bare extensions ("pdf") gain a leading dot; invalid tokens drop.
// JS toLowerCase is locale-independent — do not switch to toLocaleLowerCase.

const EXTENSION_TOKEN_PATTERN: RegExp = /^\.[a-z0-9]+(\.[a-z0-9]+)*$/;
const MIME_TOKEN_PATTERN: RegExp = /^[a-z0-9-]+\/(\*|[a-z0-9.+-]+)$/;

export const normalizeAcceptToken = (token: string): string | null => {
  const trimmed: string = token.trim().toLowerCase();
  if (!trimmed) {
    return null;
  }
  if (trimmed.includes("/")) {
    return MIME_TOKEN_PATTERN.test(trimmed) ? trimmed : null;
  }
  const withDot: string = trimmed.startsWith(".") ? trimmed : `.${trimmed}`;
  return EXTENSION_TOKEN_PATTERN.test(withDot) ? withDot : null;
};

export const normalizeAcceptValue = (tokens: string[]): string => {
  const normalized: string[] = [];
  for (const token of tokens) {
    const normalizedToken: string | null = normalizeAcceptToken(token);
    if (normalizedToken !== null && !normalized.includes(normalizedToken)) {
      normalized.push(normalizedToken);
    }
  }
  return normalized.join(",");
};
